/**
 * What gets dropped while the session-expired modal is on screen.
 * - `all`    keeps the session-expired modal the only thing visible.
 * - `errors` still lets success / info messages through.
 * - `none`   shows everything, stacked on top of the session-expired modal.
 */
export type TSessionExpirySuppression = 'all' | 'errors' | 'none'

export const defaultAppConfig = {
    auth: {
        socialButtonEnabled: false,
        showForgotPassword: true,
        showSignup: false,
        showTermAndServiceCheckbox: false
    },
    settings: {
        roleBasedAccessControl: true,
    },
    form: {
        floatingInput: false,
    },
    notification: {
        /** Errors arriving together render as one dialog with a row each, instead of one dialog per error. */
        clubNotifications: true,
        /** Upper bound on rows in a clubbed dialog, so a burst of failures cannot grow it without limit. */
        maxClubbedNotifications: 5,
        /** See {@link TSessionExpirySuppression}. Flip this to change what survives a token expiry. */
        suppressOnSessionExpiry: 'all' as TSessionExpirySuppression,
    }
}